export enum UtmReentrySource {
  Multiposting = 'multiposting',
  Blog = 'blog',
  OrganicJdp = 'organic_jdp',
  OrganicLlp = 'organic_llp',
  PaidAds = 'paid_ads',
  Other = 'other',
}
